import { render, staticRenderFns } from "./appBarNotificationCenter.vue?vue&type=template&id=2f0ab2ea"
import script from "./appBarNotificationCenter.vue?vue&type=script&lang=ts"
export * from "./appBarNotificationCenter.vue?vue&type=script&lang=ts"
import style0 from "./appBarNotificationCenter.vue?vue&type=style&index=0&id=2f0ab2ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports